var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Ebene_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 29 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1,.cls-2{fill:none;}.cls-1,.cls-3{stroke-width:0px;}.cls-2{stroke:#b70d7f;stroke-width:2px;}.cls-4{isolation:isolate;}.cls-3{fill:#b70d7f;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_3",
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M10.15,19.13v-2.15c.75.55,1.62.82,2.62.82.63,0,1.12-.14,1.47-.41s.53-.65.53-1.13-.22-.89-.65-1.16c-.44-.27-1.03-.41-1.79-.41h-1.01v-1.89h.93c1.46,0,2.19-.48,2.19-1.45,0-.91-.56-1.37-1.68-1.37-.75,0-1.48.24-2.19.73v-2.02c.79-.4,1.7-.59,2.75-.59,1.15,0,2.04.26,2.68.77.64.52.96,1.18.96,2.01,0,1.46-.74,2.38-2.23,2.75v.04c.79.1,1.42.39,1.88.86.46.48.69,1.06.69,1.75,0,1.05-.38,1.88-1.15,2.48s-1.82.91-3.17.91c-1.16,0-2.1-.19-2.82-.56Z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_4"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14,
    cy: 14.5,
    r: 12
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-2",
    cx: 14,
    cy: 14.5,
    r: 11
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg3);
export default __webpack_public_path__ + "static/media/3.64746e9c40cbf1ba68139bd34d58c9cf.svg";
export { ForwardRef as ReactComponent };